import React from 'react';

import { cn } from '../../utils/cn';

/**
 * Renders a heading component with the given children.
 *
 * @param {Object} children - The content to be displayed within the heading.
 * @return {JSX.Element} The heading component.
 */
export default function Heading({ children, className }) {
  return (
    <h1 className={cn('heading-title flex items-center text-3xl font-semibold', className)}>
      {children}
    </h1>
  );
}
